import React from "react";
import { Link } from "react-router-dom";

const NotFoundPage = () => (
  <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-pink-50 to-primary-100 text-center px-4">
    <div className="mb-8">
      <span className="inline-block bg-primary-600 rounded-full p-6 shadow-lg">
        <svg width="64" height="64" fill="none" viewBox="0 0 64 64">
          <circle cx="32" cy="32" r="32" fill="#b799c8" />
          <text
            x="32"
            y="42"
            textAnchor="middle"
            fontSize="32"
            fill="#fff"
            fontWeight="bold"
          >
            404
          </text>
        </svg>
      </span>
    </div>
    <h1
      className="text-4xl font-bold text-primary-700 mb-4"
      style={{ fontSize: "2.5rem", margin: "0.67em 0" }}
    >
      Page Not Found
    </h1>
    <p className="text-lg text-secondary-600 mb-8">
      Sorry, the page you are looking for does not exist or has been moved.
    </p>
    <Link
      to="/"
      className="inline-block px-8 py-3 bg-primary-600 text-white font-semibold rounded-full shadow hover:bg-primary-700 transition"
    >
      Go to Homepage
    </Link>
  </div>
);

export default NotFoundPage;
